import { type CurrencyCode } from "@/lib/utils";

// INTERFACES
export interface ISubscriptionPlan {
  currency: CurrencyCode;
  description: string;
  duration: number;
  maxModuleCount: number;
  planID: number;
  price: number;
  subcriptionType: SubscriptionType;
}

export interface IPermission {
  permissionID: number;
  permissionName: string;
}

export interface ISubModule {
  permissions: IPermission[];
  subModuleID: number;
  subModuleName: string;
}

export interface IModule {
  collection: string | null;
  isDefault: boolean;
  moduleID: number;
  moduleName: string;
  subModules: ISubModule[];
}

export interface ITenantModules {
  moduleID: number;
  subModulesList: string[];
}

export interface ISubscriptionInfo {
  currency: string;
  expiryDate: string;
  isActive: boolean;
  isPromoActive: boolean;
  moduleDetails: ITenantModules[];
  startDate: string;
  subscriptionType: SubscriptionType;
}

export interface ITenantState {
  loading: boolean;
  modules: IModule[] | null;
  modulesLoading: boolean;
  modulesMsg: string | null;
  modulesSuccess: boolean;
  plansList: ISubscriptionPlan | null;
  plansListMsg: string | null;
  plansListSuccess: boolean;
  saving: boolean;
  saveTenantMsg: string | null;
  saveTenantSuccess: boolean;
  tenantInfo: ISubscriptionInfo | null;
  tenantInfoMsg: string | null;
  tenantInfoSuccess: boolean;
  updateTenantPlanMsg: string | null;
  updateTenantPlanSuccess: boolean;
  provisioningOperationId: string | null;
  provisioningProgress: number;
  provisioningStep: string;
  provisioningStatus: string | null;
  provisioningError: string | null;
  provisioningUsingPolling: boolean;
  isProvisioning: boolean;
}

export interface IUpdateTenantPayload {
  ModuleIDs: number[];
  SubscriptionType: SubscriptionType;
}

export interface IProvisioningSignalRInfo {
  hubUrl: string;
  channel?: string;
}

export interface IProvisioningInitResponse {
  operationId: string;
  status?: string;
  signalR?: IProvisioningSignalRInfo;
  statusUrl?: string;
}

export interface IProvisioningProgressEvent {
  progress: number;
  step: string;
}

export interface IProvisioningResult {
  message: string;
  success: boolean;
  timestamp: string;
}

export interface IProvisioningStatusResponse {
  operationId: string;
  status: string;
  progress: number;
  currentStep?: string;
  createdAt?: string | null;
  startedAt?: string | null;
  updatedAt?: string | null;
  finishedAt?: string | null;
  result?: IProvisioningResult | null;
  error?: string | null;
}

// ENUMS
export enum SubscriptionType {
  BASIC = "Basic",
  PREMIUM = "Premium",
  ENTERPRISE = "Enterprise",
};